import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import type { Project } from '@/api'

export const useProjectStore = defineStore('project', () => {
  const projects = ref<Project[]>([])
  const currentProject = ref<Project | null>(null)
  const loading = ref(false)

  const pendingProjects = computed(() => 
    projects.value.filter(p => ['pending_confirm', 'waiting_script_approval', 'waiting_storyboard_approval', 'waiting_final_review', 'waiting_client_acceptance', 'reviewing'].includes(p.status))
  )

  const activeProjects = computed(() => 
    projects.value.filter(p => ['confirmed', 'in_progress', 'revision_in_progress'].includes(p.status))
  )

  function setProjects(list: Project[]) {
    projects.value = list
  }

  function addProject(project: Project) {
    projects.value.unshift(project)
  }

  function updateProject(id: Project['id'], updates: Partial<Project>) {
    const index = projects.value.findIndex(p => p.id === id)
    if (index !== -1) {
      projects.value[index] = { ...projects.value[index], ...updates }
    }
    if (currentProject.value?.id === id) {
      currentProject.value = { ...currentProject.value, ...updates }
    }
  }

  function setCurrentProject(project: Project | null) {
    currentProject.value = project
  }

  function setLoading(value: boolean) {
    loading.value = value
  }

  return {
    projects,
    currentProject,
    loading,
    pendingProjects,
    activeProjects,
    setProjects,
    addProject,
    updateProject,
    setCurrentProject,
    setLoading,
  }
})
